import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconMapMarker(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.484 13.209a20.71 20.71 0 0 1-3.114 2.679.668.668 0 0 1-.74 0 19.19 19.19 0 0 1-.983-.731 20.71 20.71 0 0 1-2.131-1.948c-1.981-2.091-3.183-4.294-3.183-6.542a6.667 6.667 0 0 1 13.334 0c0 2.248-1.202 4.451-3.183 6.542zm-2.962.905a19.518 19.518 0 0 0 1.994-1.822c1.769-1.867 2.817-3.789 2.817-5.625a5.333 5.333 0 1 0-10.666 0c0 1.836 1.048 3.758 2.817 5.625A19.404 19.404 0 0 0 8 14.515c.162-.119.337-.253.522-.401zM8 9.333a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334zM8 8a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 8z"
  }));
}
IconMapMarker.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconMapMarker.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconMapMarker as default };
